import { AiQueryKeys } from "#lib/AiQueryKeys.ts";
import type { Conversation } from "#types/types.ts";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router";

/**
 * Determines the feature value for page view tracking based on conversation context.
 * Returns "Smart Report" for smart report conversations, undefined otherwise.
 *
 * @returns The feature name if applicable, undefined otherwise
 */
export const usePageViewFeature = (): string | undefined => {
    const queryClient = useQueryClient();
    const { conversationId } = useParams<{ conversationId?: string }>();

    if (!conversationId) {
        return undefined;
    }

    const conversation = queryClient.getQueryData<Conversation>(
        AiQueryKeys.GetConversation(conversationId)
    );

    return conversation?.discriminator === "smart_report" ? "Smart Report" : undefined;
};
